// extracted by mini-css-extract-plugin
export default {"price":"W7-z","priceRow":"X7-z","onSale":"Y7-z","msrpLabelPrice":"Z7-z","msrpLabel":"_7-z","originalPrice":"a8-z","percentOff":"b8-z"};